import React, { useEffect } from 'react';
import styled from 'styled-components';

import { User } from '~/api/account/accountApiTypes';
import Modal from '~/atomic/molecula/Modal';
import { confirmEmailCode, quickRegister } from '~/feature/authorization/auth.data';
import { authSelector } from '~/feature/authorization/auth.selector';
import { QuickRegisterForm } from '~/feature/authorization/quickAuth/QuickRegisterForm';
import { choosePaySelector } from '~/feature/finance/BuyingSteps/ChoosePay/choosePay.selector';
import { activateCatalogTimerDiscount } from '~/feature/withTiwerDiscount/activateCatalogTimerDiscount/activateCatalogTimerDiscount.data';
import { activateCatalogTimerDiscountSelector } from '~/feature/withTiwerDiscount/activateCatalogTimerDiscount/activateCatalogTimerDiscount.selector';
import { activateCatalogTimerDiscountActions } from '~/feature/withTiwerDiscount/activateCatalogTimerDiscount/activateCatalogTimerDiscount.slice';
import { ym } from '~/feature/yandex/YandexMetrikaInit';
import { lessThan } from '~/lib/mediaQuery';
import { useAppDispatch, useAppSelector } from '~/store';

export const RegisterModalWithActivateCatalogTimerDiscount = () => {
  const dispatch = useAppDispatch();
  const { isOpenRegisterModalWithActivateCatalogTimerDiscount } = useAppSelector(activateCatalogTimerDiscountSelector);
  const { quickAuthEmail } = useAppSelector(choosePaySelector);
  const { loading } = useAppSelector(authSelector);

  useEffect(() => {
    if (isOpenRegisterModalWithActivateCatalogTimerDiscount) {
      ym('reachGoal', 'open-register-modal');
    }
  }, [isOpenRegisterModalWithActivateCatalogTimerDiscount]);

  const closeModal = () => {
    dispatch(activateCatalogTimerDiscountActions.setIsOpenRegisterModalWithActivateCatalogTimerDiscount(false));
  };

  const afterLogin = async (user: User) => {
    dispatch(activateCatalogTimerDiscount());
    closeModal();
  };

  const confirmQuickRegistration = async () => {
    ym('reachGoal', 'click-quick-register-modal');
    await dispatch(quickRegister({ email: quickAuthEmail, afterLogin }));
  };

  const confirmCode = async (code: string) => {
    ym('reachGoal', 'confirm-code-register');
    await dispatch(confirmEmailCode({ code, afterLogin }));
  };

  const onBackClick = () => {
    closeModal();
    dispatch(activateCatalogTimerDiscountActions.setIsOpenAuthModalWithActivateCatalogTimerDiscount(true));
  };

  return (
    <SCAuthModal
      onCancel={closeModal}
      open={isOpenRegisterModalWithActivateCatalogTimerDiscount}
    >
      <QuickRegisterForm
        onBackClick={onBackClick}
        confirmQuickRegistration={confirmQuickRegistration}
        confirmCode={confirmCode}
        isLoading={loading.quickRegister === true || loading.confirmEmailCode === true}
        email={quickAuthEmail}
        nextButtonText="Войти"
        label={(
          <>
            Не хочу отвлекаться от чтения!
            <br />
            Подтверждаю, что адрес почты указан верно.
            <br />
            Для последующего входа в аккаунт попрошу прислать код на почту.
          </>
        )}
      />
    </SCAuthModal>
  );
};

export const SCAuthModal = styled(Modal)`
  max-width: 458px;

  .ant-modal-body {
    padding-top: 23px;
    padding-bottom: 23px;
  }

  ${lessThan('xs')} {
    max-width: 100vw;
    top: 0;
  }
`;
